const types = {
 //userDetail
 GET_ARTICLE: "GET_ARTICLE",
 GET_ARTICLE_RESPONSE: "GET_ARTICLE_RESPONSE",


}

export default types;